module.exports = __webpack_public_path__ + "static/media/ava.d5d29ba0.svg";